import { Stack, useLocalSearchParams } from 'expo-router';

import { FruitSliceFramePage } from '../../../../../fruit-slices/components/FruitSliceFramePage';
import { FruitSlicePageBackground } from '../../../../../fruit-slices/components/FruitSlicePageBackground';

export default function FruitSliceFrameRoute() {
    const { id, frameId } = useLocalSearchParams<{
        id: string;
        frameId: string;
    }>();

    return (
        <>
            <Stack.Screen options={{ title: 'Fruit Slice Frame' }} />
            <FruitSlicePageBackground>
                <FruitSliceFramePage sliceId={id} frameId={frameId} />
            </FruitSlicePageBackground>
        </>
    );
}
